import {
  Activity,
  AnyEntity,
  Company,
  Deal,
  EntityType,
  Person,
} from "@mapmycustomers/shared/types/entity";
import GeoPoint from "@mapmycustomers/shared/types/shapes/GeoPoint";

const defaultGeoPointGetter = <T extends AnyEntity>(
  entity: T,
  entityType: EntityType
): GeoPoint | undefined => {
  switch (entityType) {
    case EntityType.ACTIVITY: {
      const activity = entity as Activity;
      return (
        activity.account?.geoPoint ||
        activity.contact?.geoPoint ||
        activity.deal?.geoPoint ||
        undefined
      );
    }
    case EntityType.COMPANY:
      return (entity as Company).geoPoint || undefined;
    case EntityType.DEAL:
      return (entity as Deal).account?.geoPoint || (entity as Deal).contact?.geoPoint || undefined;
    case EntityType.PERSON:
      return (entity as Person).geoPoint || undefined;
    default:
      return undefined;
  }
};

export default defaultGeoPointGetter;
